import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';
import { CloseButton } from '@spotahome/ui-library';

import classNames from 'classnames';

import mapPointShape from '../../shapes/mapPoint';
import SearchIcon from '../icons/SearchIcon';

import useAutocompleteService from './useAutocompleteService';
import PlacesAutocompleteSuggestion from './PlacesAutocompleteSuggestion';

import './PlacesAutocomplete.scss';

const BASE_CLASS = 'places-autocomplete';

const noop = () => {};

const PlacesAutocomplete = ({
  pointOfInterest = undefined,
  boundCoords,
  countryCode = undefined,
  cityName,
  onPlaceSelected = noop,
  flat = false,
  renderExtraContent = noop,
  rounded = false
}) => {
  const { handleInput, inputValue, suggestionList, placesRef, handleSelect } =
    useAutocompleteService({
      boundCoords,
      countryCode,
      pointOfInterest,
      onPlaceSelected
    });

  return (
    <div className={BASE_CLASS} data-test="map-search-bar" ref={placesRef}>
      <div className={`${BASE_CLASS}__box`}>
        <SearchIcon className={`${BASE_CLASS}__icon`} />
        <input
          className={classNames(`${BASE_CLASS}__input`, {
            [`${BASE_CLASS}__input--flat`]: flat,
            [`${BASE_CLASS}__input--rounded`]: rounded
          })}
          type="text"
          value={inputValue}
          onChange={handleInput}
          placeholder={trans('rentable_unit_map.autocomplete.placeholder', {
            city: cityName
          })}
        />
        {pointOfInterest && (
          <CloseButton
            onClick={() => onPlaceSelected(null)}
            className={`${BASE_CLASS}__clear`}
            role="button"
            tabIndex={0}
            data-test="map-search-clear"
          />
        )}
      </div>
      {suggestionList.length ? (
        <ul
          className={`${BASE_CLASS}__suggestions`}
          data-test="poi-search-suggestions"
        >
          {suggestionList.map(suggestion => (
            <PlacesAutocompleteSuggestion
              key={suggestion.place_id}
              structuredFormatting={suggestion.structured_formatting}
              onClick={handleSelect(
                suggestion.place_id,
                suggestion.description
              )}
            />
          ))}
        </ul>
      ) : null}
      {renderExtraContent()}
    </div>
  );
};

PlacesAutocomplete.propTypes = {
  boundCoords: PropTypes.shape(mapPointShape).isRequired,
  pointOfInterest: PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number,
    name: PropTypes.string,
    placeId: PropTypes.string
  }),
  countryCode: PropTypes.string,
  cityName: PropTypes.string.isRequired,
  flat: PropTypes.bool,
  onPlaceSelected: PropTypes.func,
  renderExtraContent: PropTypes.func,
  rounded: PropTypes.bool
};

export default PlacesAutocomplete;
